/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { LinkButton } from '@blend/enterprise-components';
import { useFormState } from 'react-final-form';
import { useHistory } from 'react-router';
import { isForSecondaryAuthQueryParam } from 'blb-utils/secondaryAuth';

export namespace ForgotPasswordLinkButton {
  export interface Props {
    usernameFromParams?: string;
  }
}

export const ForgotPasswordLinkButton: React.FC<ForgotPasswordLinkButton.Props> = ({ usernameFromParams }) => {
  const {
    values: { username },
  } = useFormState<{ username: string }>();
  const userEmail = usernameFromParams || username;
  const history = useHistory();
  const params = new URLSearchParams();
  if (userEmail) {
    params.append('username', userEmail);
  }
  // if this is a route for secondary auth login
  const forSecondaryAuth = isForSecondaryAuthQueryParam();
  if (forSecondaryAuth) {
    params.append('forSecondary', forSecondaryAuth);
  }
  return (
    <LinkButton
      id="it-ForgotPassword"
      label="Forgot Password?"
      onClick={() => {
        // TODO: BRG-727 Handle an encoded username value on the FE
        return history.push({
          pathname: `/forgot-password`,
          search: params.toString(),
        });
      }}
    />
  );
};
